<template>
    <div>
        <div class="content w1200">
            <div class="left">
                <kaijiang></kaijiang>
                <div>
                    <div class="svc-card" @click="openInNewTab('/dataupdate', 7)">
                        <div class="svc-card__head">
                            <span class="svc-card__name">任意软件开奖数据更新</span>
                            <span class="svc-card__badge">推荐</span>
                        </div>
                        <div class="svc-card__desc">上传旧数据 · 一键转标准格式</div>
                        <div class="svc-card__btn">立即使用 →</div>
                    </div>
                </div>
            </div>
            <div class="cont">
                <el-carousel height="475px">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <el-image style="width: 100%; height: 100%;" :src="item.img" fit="fit"
                            @click="gotoPage(item)"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="right">
                <div class="rg_one">
                    <div class="user" @click="$router.push('/personalCenter/userinfo/yhzx')"><b>{{
                        vuex_userInfo.nickName
                        || '' }}</b> 欢迎您</div>
                    <div class="shrinkRecharge" @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">
                        <span>缩币充值</span>
                    </div>
                </div>
                <div class="cont">
                    <div class="nav">
                        <span v-for="(item, index) in notice_help.nav.arr" :key="index"
                            :class="{ active: notice_help.nav.active == index }"
                            @click="notice_help.nav.active = index; getHelp_notice(index)">{{ item }}</span>
                    </div>
                    <div class="list">
                        <template v-if="notice_help.nav.active == 0">
                            <div v-for="(item, index) in notice_help.noticeList" :key="index"
                                @click="gotoArticle_details(item, 'notice')">
                                <div>{{ item.noticeTitle }}</div>
                                <span style="width: 100px; text-align: right;">{{ item.createTime.substring(2, 10)
                                }}</span>
                            </div>
                        </template>
                        <template v-if="notice_help.nav.active == 1">
                            <div v-for="(item, index) in notice_help.helpList" :key="index"
                                @click="gotoArticle_details(item, 'help')">
                                <div>{{ item.title }}</div>
                                <span>{{ item.createTime.substring(2, 10) }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- <div class="btn" v-if="!vuex_userInfo.nickName">
                    <div @click="$router.push('/login')">登录</div>
                    <div @click="$router.push('/login/register')">注册</div>
                    <div @click="$router.push('/login/forgetPassword')">
                        忘记密码
                    </div>
                </div> -->
            </div>
        </div>

        <ssq></ssq>
        <dlt></dlt>
        <fcsd></fcsd>
        <pls></pls>

        <img src="@/assets/indexBottom.png" alt="" class="w1200" style="margin: 20px auto; display: block" />

        <div class="dibudaxiang">
            <span @click="openInNewTab('/ssddt', 1)">缩水单大厅</span>
            <span @click="openInNewTab('/excel', 4)">EXCEL转场</span>
            <span @click="openInNewTab('/suoshuiruanjian', 5)">缩水软件特区</span>
            <span @click="openInNewTab('/sttzzbfzx', 6)">投注站帮扶中心</span>
        </div>

    </div>
</template>

<script>
import ssq from "./template/ssq.vue";
import dlt from "./template/dlt.vue";
import fcsd from "./template/fcsd.vue";
import pls from "./template/pls.vue";
import kaijiang from "./template/kaijiang.vue";

import { bannerApi, help, notice } from '@/api/home/index'

export default {
    components: { ssq, dlt, fcsd, pls, kaijiang, },
    data() {
        return {
            banner: [],
            notice_help: {
                nav: {
                    active: 0,
                    arr: ["网站公告", "帮助中心"],
                },
                noticeList: [],
                helpList: [],
            },
        };
    },
    mounted() {
        this.getBanner()
        this.getHelp_notice()
    },
    methods: {
        openInNewTab(path, menuActiveIndex = null) {

            if (menuActiveIndex === '') { return }

            this.$vuex('vuex_menuActiveIndex', menuActiveIndex)

            const env = process.env.NODE_ENV;
            let obj = {
                development: window.location.origin, // 本地开发：跟随 dev server 实际地址（如 http://localhost:8085）
                production: process.env.VUE_APP_BASE_API, // 线上地址
            }

            const fullUrl = `${obj[env]}#${path}`;
            window.open(fullUrl, '_blank');
        },
        getBanner() {
            bannerApi().then(res => {
                // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是 {rows:[...]} 或裸数组
                const payload = res && res.data !== undefined ? res.data : res;
                const rows = Array.isArray(payload) ? payload : (payload && payload.rows) || [];
                let db = rows.filter(item => item.status == 0);
                let baseUrl = process.env.VUE_APP_BASE_API + '/stage-api';
                db.forEach(item => item.img = baseUrl + item.img);
                this.banner = db
            }).catch(err => {
                console.error('banner 加载失败', err);
                this.banner = []
            })
        },
        gotoPage(item) {
            window.open(item.link, '_blank')
        },

        getHelp_notice(index = 0) {
            // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是 {rows:[...]} 或裸数组
            const extract = (res) => {
                const payload = res && res.data !== undefined ? res.data : res;
                const rows = Array.isArray(payload) ? payload : (payload && payload.rows) || [];
                return rows.slice(0, 9)
            }

            if (index == 0) {
                notice(index).then(res => {
                    this.notice_help.noticeList = extract(res)
                }).catch(err => {
                    console.error('公告加载失败', err);
                    this.notice_help.noticeList = []
                })
            } else {
                help().then(res => {
                    this.notice_help.helpList = extract(res)
                }).catch(err => {
                    console.error('帮助中心加载失败', err);
                    this.notice_help.helpList = []
                })
            }

        },

        gotoArticle_details(item, type) {
            // console.log('ss',JSON.parse(JSON.stringify(item)));
            let id = type == 'notice' ? item.noticeId : item.id;
            // console.log('id',id);
            // this.$vuex('vuex_articleDetails', item)
            this.$router.push({
                name: 'article_details',
                query: { id, type }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;

    >div {

        &.left,
        &.right {
            width: 300px;
            position: relative;

            .btn {
                display: flex;

                div {
                    width: 33%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    text-align: center;
                    padding: 10px 0;
                    cursor: pointer;
                }
            }
        }

        &.cont {
            flex: 1;
            background: rgba(0, 0, 0, 0.2);
        }

        &.left {
            .title {
                padding: 20px;
                padding-bottom: 10px;
                font-size: 20px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            }

            >div:nth-child(n + 2) {

                .tit {
                    font-size: 20px;
                    padding: 15px 0 5px;
                }

                .cont {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);

                    span {
                        padding: 2px 0;
                        font-size: 14px;
                        cursor: pointer;
                        width: max-content;

                        transform-origin: center;
                        transition: transform 0.5s;

                        position: relative;
                        color: #3072cd;

                        &:hover {
                            transform: scale(1.5);
                            font-weight: bold;

                            // text-decoration: underline;
                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }

                        &:not(:hover) {
                            transform: scale(1);
                            font-weight: inherit;

                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }

            // 数据服务入口：做成高亮卡片，避免被当作普通文字链接忽略
            .svc-card {
                margin: 10px;
                padding: 12px 14px;
                border-radius: 8px;
                background: linear-gradient(135deg, #3072cd 0%, #5b9bf5 100%);
                color: #fff;
                cursor: pointer;
                box-shadow: 0 4px 12px rgba(48, 114, 205, 0.35);
                transition: transform 0.25s, box-shadow 0.25s;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 18px rgba(48, 114, 205, 0.5);
                }

                &__head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                &__name {
                    font-size: 15px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                }

                &__badge {
                    font-size: 11px;
                    line-height: 1;
                    padding: 3px 6px;
                    border-radius: 3px;
                    background: #ffd666;
                    color: #ad6800;
                    font-weight: 700;
                }

                &__desc {
                    font-size: 12px;
                    opacity: 0.9;
                    margin-top: 6px;
                }

                &__btn {
                    margin-top: 10px;
                    padding: 5px 0;
                    font-size: 12px;
                    text-align: center;
                    border-radius: 4px;
                    background: rgba(255, 255, 255, 0.22);
                    transition: background 0.25s;

                    &:hover {
                        background: rgba(255, 255, 255, 0.35);
                    }
                }
            }
        }

        &.right {
            padding: 10px;

            .rg_one {
                display: flex;

                >div {
                    cursor: pointer;
                    height: 50px;
                    line-height: 50px;
                    flex: 1;
                    text-align: center;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    position: relative;

                    &.user {
                        background-color: #f4ce98;
                        color: #bd392f;
                    }

                    &.shrinkRecharge {
                        // background-color: #347CAF;
                        background-color: red;
                        color: #fff;
                        flex: 0.4;
                        transition: padding 0.5s linear;

                        &:hover {
                            padding: 0 30px;

                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }

                        &:not(:hover) {
                            padding: 0 0px;
                            font-weight: inherit;

                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }

            .cont {
                margin: auto;
                // border: 1px solid red;
                display: flex;
                flex-direction: column;
                align-items: center;

                .nav {
                    width: 65%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 0px 0 5px;
                    color: #347caf;
                    font-weight: bold;

                    span {
                        cursor: pointer;
                        font-size: 20px;
                        border-bottom: 3px solid rgba(0, 0, 0, 0.1);
                        padding: 10px 0;
                        text-align: center;

                        &.active {
                            border-bottom: 3px solid #347caf;
                        }
                    }
                }

                .list {
                    width: 95%;

                    div {
                        display: flex;
                        justify-content: space-between;
                        // padding: 10px;
                        line-height: 30px;
                        cursor: pointer;

                        div {
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                            display: block;

                            &:hover {
                                transition: transform 0.5s;
                                transform: scale(1.1);
                                font-weight: bold;
                                transform-origin: left;
                            }

                            &:not(:hover) {
                                transition: transform 0.5s;
                                transform: scale(1);
                                font-weight: inherit;
                                transform-origin: left;
                            }
                        }

                        span {
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
}

.dibudaxiang {
    width: 930px;
    margin: 50px auto 80px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    span {
        white-space: nowrap;
        padding: 15px 50px;
        border: 2px solid #3d82b2;
        color: #3d82b2;
        font-weight: bold;
        border-radius: 10px;
    }
}
</style>